import { ExcelExportPanel } from '@/components/ExcelExportPanel';

export default function ExcelExports() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Excel Exports</h1>
        <p className="text-gray-600">Export business insurance data to Excel files for analysis</p>
      </div>
      
      <ExcelExportPanel />
    </div>
  );
}
